import FadedText from "@components/FadedText";
import { DropdownMenu } from "@kobalte/core";
import { For, type ParentComponent, Show } from "solid-js";
import { DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./styled";
import type { DropdownProps } from "./types";

const DropDown: ParentComponent<DropdownProps> = (props) => {
	return (
		<DropdownMenu.Root
			sameWidth
			fitViewport
			preventScroll
			gutter={10}
			open={props.open}
			onOpenChange={props.onOpenChange}
		>
			<DropdownMenuTrigger>{props.children}</DropdownMenuTrigger>
			<DropdownMenu.Portal>
				<DropdownMenuContent onCloseAutoFocus={(e) => e.preventDefault()}>
					<For each={props.items}>
						{(item) => (
							<DropdownMenuItem onSelect={item.onClick} closeOnSelect>
								<Show when={item.icon}>{item.icon}</Show>
								<Show when={typeof item.label === "string"} fallback={item.label}>
									<Show when={item.html} fallback={<FadedText>{item.label}</FadedText>}>
										<FadedText innerHTML={item.label as string} />
									</Show>
								</Show>
							</DropdownMenuItem>
						)}
					</For>
				</DropdownMenuContent>
			</DropdownMenu.Portal>
		</DropdownMenu.Root>
	);
};
export default DropDown;
